import { defaultsDeep } from 'lodash';

ReportsDailyController.$inject = [
    '$scope',
    '_',
    'moment',
    '$state',
    '$stateParams',
    'Club',
    'CONST',
    'alerts',
    'CreateCashMovementModal',
];

/* @ngInject */
function ReportsDailyController(
    $scope,
    _,
    moment,
    $state,
    $stateParams,
    Club,
    CONST,
    alerts,
    CreateCashMovementModal,
) {
    var vm = this;
    vm.title = 'ReportsDailyController';

    vm.loading = true;

    vm.report = [];
    vm.stats = {
        success: 0,
        cancelled: 0,
        online: 0,
    };

    // note
    vm.note = null;

    vm.sum = {
        price: 0,
        payed: 0,
        owes: 0,
    };
    vm.now = moment();

    vm.date = {
        current: moment($stateParams.date),
        opened: false,
        open: function () {
            vm.date.opened = true;
        },
        formats: 'DD [de] MMMM [del] YYYY',
        format: 'YYYY-MM-DD',
        options: {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: moment(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
            datepickerMode: 'day',
        },
    };

    $scope.$watch('vm.date.current', function (_current) {
        var current = moment(_current);
        $state.go('app.reports.daily', {
            date: current.format('YYYY-MM-DD'),
        });
    });

    $scope.$on('cashMovementRegistered', activate);

    activate();

    vm.editGeneralCashMovement = (movement, data) =>
        CreateCashMovementModal.open(data, { onUpdated: activate });

    function activate() {
        vm.loading = true;
        Club.API.customGET(
            'reports/daily/' + vm.date.current.format('YYYY-MM-DD'),
        )
            .then(buildStats)
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }

    function buildReport(reports) {
        return _.map(reports, function (report) {
            function getBookingNote(report) {
                let note = [];
                if (report.booking && report.booking.note) {
                    note.push(report.booking.note.text);
                    note.push(report.booking.note.by);
                }
                if (report.cancelled) {
                    note.push(report.feedback);
                }
                return note.length ? note.join(' - ') : null;
            }

            function getPlayer(report) {
                if (!report.player) {
                    return '-';
                }
                return `${report.player.name} - ${report.player.phone}`;
            }

            function getDetail(report) {
                if (report.booking && report.booking.court) {
                    return report.booking.court.name;
                } else {
                    return report.concept + ' x ' + report.quantity;
                }
            }

            return {
                bid: report.booking_id || `G-${report.id}`,
                date: report.datetime,
                booking: report.booking && {
                    player: getPlayer(report),
                    online:
                        (report.booking && report.booking.created_online) ||
                        false,
                    fixed: report.is_fixed,
                    cancelled: report.cancelled,
                    type: report.booking.type,
                    price: parseFloat(report.price),
                    owes: report.entry && parseFloat(report.entry),
                    balance: report.balance && parseFloat(report.balance),
                },
                movement_type: report.movement_type,
                complete_general_cash: {
                    id: report.id,
                    booking_id: report.booking_id,
                    concept: report.concept,
                    datetime: report.datetime,
                    payed: report.payed,
                    quantity: report.quantity,
                    value: Number(report.value),
                    item_id: report.item_id || null,
                },
                general: report.movement_type === 'general',
                player: getPlayer(report),
                done_user:
                    (
                        report.user ||
                        report.updated_by ||
                        report.created_by ||
                        {}
                    ).name || 'Cancelado online',
                done_at: moment(report.created_at).format('HH:mm [del] DD-MMM'),
                detail: getDetail(report),
                type: report.type,
                payment_type: report.payment_type,
                note: report.note || getBookingNote(report) || '-',
                payed: !report.quantity
                    ? parseFloat(report.value)
                    : parseFloat(report.value) * parseInt(report.quantity),
                item_id: report.item_id || null,
            };
        });
    }

    function groupMovements(movements) {
        const groups = [
            {
                title: 'Ingresos Por seña',
                movements: movements.filter(
                    ({ type, movement_type }) =>
                        movement_type === 'booking' && type === 'deposit',
                ),
            },
            {
                title: 'Ingresos Por canchas',
                movements: movements.filter(
                    ({ type, movement_type }) =>
                        movement_type === 'booking' && type !== 'deposit',
                ),
            },
            {
                title: 'Ingresos generales',
                movements: movements.filter(
                    ({ type, movement_type }) =>
                        movement_type === 'general' && type === 'deposit',
                ),
            },
            {
                title: 'Egresos',
                movements: movements.filter(
                    ({ type, movement_type }) =>
                        movement_type === 'general' && type === 'extraction',
                ),
            },
        ].filter((it) => it.movements.length > 0);
        groups.forEach((it) => (it.partial = _.sumBy(it.movements, 'payed')));
        return groups;
    }

    function buildStats(result) {
        // Report
        const allMovements = buildReport(result.report);

        vm.report = groupMovements(allMovements);

        // Extract duplicate price same booking
        var report = _.uniqBy(allMovements, 'bid');

        // Sum
        vm.sum.price = _.sumBy(report, 'price');
        vm.sum.entry = _.sumBy(allMovements, 'entry');
        vm.sum.payed = _.sumBy(allMovements, 'payed');
        vm.sum.owes = _.sumBy(allMovements, 'owes');
        // Totals
        vm.stats = result.summary;
        vm.totals = {
            cash: result.totals.cash ? parseFloat(result.totals.cash.total) : 0,
            credit_card: result.totals.credit_card
                ? parseFloat(result.totals.credit_card.total)
                : 0,
            debit_card: result.totals.debit_card
                ? parseFloat(result.totals.debit_card.total)
                : 0,
            mercado_pago: result.totals.mercado_pago
                ? parseFloat(result.totals.mercado_pago.total)
                : 0,
            transfer: result.totals.transfer
                ? parseFloat(result.totals.transfer.total)
                : 0,
            check: result.totals.check
                ? parseFloat(result.totals.check.total)
                : 0,
        };
    }
}

export default ReportsDailyController;
